import { Input, Select, Tag } from 'antd';
import { LIST_TYPE, PROJECT_STATUS } from 'constants/constants';
import usePage from 'hooks/usePage';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import Page from 'views/common/Page';
import SmartTable from 'views/common/table/SmartTable';

const DEFAULT_PAGE = 10;

const getDate = (date) => {
  if (!date) return;
  return moment(new Date(date)).format('DD/MM/yyyy');
};

const config = {
  mainKey: 'id',
  headerHeight: 50,
  rowHeight: 60,
  tableStyle: {
    minWidth: 700,
    maxHeight: 660,
  },
  columns: [
    {
      columnKey: 'No',
      title: 'No.',
      className: 'cell-y-center',
      render: (v, rowData) => {
        const { index } = rowData;
        return <span style={{ fontWeight: 400, paddingLeft: 5 }}>{index}</span>;
      },
      width: '2rem',
    },
    {
      columnKey: 'name',
      title: 'Function name',
      width: '25%',
      className: 'cell-y-center',
      render: (value, rowData) => (
        <Link to={rowData.id}>
          <span className="cell-link-to text">{value}</span>
        </Link>
      ),
    },
    {
      columnKey: 'description',
      title: 'Description',
      width: '40%',

      className: 'cell-y-center',
    },
    {
      columnKey: 'status',
      title: 'Status',
      width: '10%',
      className: 'cell-y-center',
      render: (v, rowData) => {
        return <Tag>{rowData.pause ? 'PAUSE' : v}</Tag>;
      },
    },
    {
      columnKey: 'versionName',
      title: 'Version',
      width: '10%',
      className: 'cell-y-center',
      render: (v, rowData) => {
        return v > 0 && <Tag>v.{v}</Tag>;
      },
    },
    {
      columnKey: 'modifiedDate',
      title: 'Sent date',
      width: '20%',
      className: 'cell-y-center',
      render: (v) => <span>{getDate(v)}</span>,
    },
    {
      columnKey: 'createdBy',
      title: 'Owner',
      width: '10%',

      className: 'cell-y-center',
    },
  ],
};

const ProjectApprove = () => {
  const {
    status,
    data,
    meta,
    search,
    onChangeFieldText,
    onChangeField,
    onChangePage,
    currentPage,
  } = usePage({
    name: LIST_TYPE.PROJECT_APPROVE,
    pageSize: DEFAULT_PAGE,
    defaultParams: {
      pause: false,
      status: PROJECT_STATUS.WAITING_APPROVE
    }
  });

  const onChangeStatus = (v) => {
    if (!v) {
      onChangeField(null, 'pause');
      return onChangeField(v, 'status');
    }

    if (v === 'PAUSE') {
      onChangeField(true, 'pause');
      return onChangeField(null, 'status');
    }

    onChangeField(false, 'pause');
    return onChangeField(v, 'status');
  };

  return (
    <Page
      title="Project"
      status={status}
      data={data}
      currentPage={currentPage}
      pageSize={DEFAULT_PAGE}
      onChangePage={onChangePage}
      meta={meta}
      renderSearch={() => (
        <div className="page-search">
          <Input
            className="page-search__input"
            placeholder="Search for id, name and description"
            value={search.query}
            onChange={(e) => onChangeFieldText(e, 'query')}
            size="large"
          />
          <Select
            className="page-search__select"
            placeholder="Status"
            allowClear
            value={search.status || (search.pause && 'PAUSE')}
            onChange={onChangeStatus}
            size="large"
            onClear={() => {
              onChangeField(null, 'pause');
            }}
            options={[
              {
                label: 'Waiting Approve',
                value: PROJECT_STATUS.WAITING_APPROVE,
              },
              {
                label: 'Approved',
                value: PROJECT_STATUS.APPROVED,
              },
              {
                label: 'Pause',
                value: 'PAUSE',
              },
            ]}
          />
        </div>
      )}
      renderList={() => (
        <div className="table-item-wraper">
          <SmartTable config={config} dataSource={data} />
        </div>
      )}
    />
  );
};

export default ProjectApprove;
